/* eslint-disable react/prop-types */

import React, { memo } from 'react';

import { DeviceInfo } from '@ezugi/utils';

import { getColor } from './utils';

function Circle({
  coordinates: [ y, x ],
  WinningHand,
  CardHandValue,
  isBankerPair,
  isPlayerPair,
  style,
  className,
  isPlayerNaturalHand,
  isBankerNaturalHand,
  tieCount,
  gameId,
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1"
      height="1"
      x={x}
      y={y}
      style={style}
      className={className}
      data-value={CardHandValue}
      data-winner={WinningHand}
      data-tie-count={tieCount}
      data-player-pair={isPlayerPair}
      data-banker-pair={isBankerPair}
      data-natural-hand={isPlayerNaturalHand || isBankerNaturalHand}
    >
      <circle cx="12" cy="12" r="10" fill={getColor(gameId, WinningHand)} />
      {isBankerPair
        && <circle cx="5" cy="7" r="3" fill={getColor(gameId, 'Banker')} strokeWidth="1.5" stroke="#fff" />}
      {isPlayerPair
        && <circle cx="19" cy="17" r="3" fill={getColor(gameId, 'Player')} strokeWidth="1.5" stroke="#fff" />}
      <text
        x="50%"
        y={DeviceInfo.isMicrosoftBrowser ? 17 : '50%'}
        textAnchor="middle"
        dominantBaseline="central"
        fontSize="14"
        fill="#fff"
      >
        {CardHandValue}
      </text>
    </svg>
  );
}

export default memo(Circle);
